import {DictionaryItem} from './dictionary.model';
import {Localization} from './localization.model';
import {Partner} from './partner.model';
import {GenericEntity} from './generic-entity.model';
import {PermissionArea} from '../enums/permission-area.enum';
import {UserOperation} from '../enums/operations.enum';

export class SystemUser extends GenericEntity {
    email?: string;
    isActive?: boolean;
    isBlocked?: boolean;
    localization?: Localization;
    username: string;
    firstName?: string;
    partner?: Partner;
    role?: DictionaryItem;
    roles?: string[];
    pesel?: string;
    lastName?: string;
    fullName?: string;
    technicalName?: string;
    numberOfwca?: string;
    availablePermissionAreas: PermissionArea[];
    availableOperations: UserOperation[];

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }

    isOperationEnabled(operation: UserOperation) {
        return this.availableOperations?.includes(operation);
    }
}

export class SystemUserSimple extends GenericEntity {
    username: string;
    firstName: string;
    lastName: string;
    technicalName: string;
    email: string;

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }

    get fullName() {
        return this.firstName || this.lastName
            ? `${this.firstName} ${this.lastName}`
            : this.technicalName ?? '';
    }
}
